<template>
  <FrontPageTmpl @openFreeTrial="openFreeTrial">
    <Banner :imgs="bannerImgs">
      <div class="slogan">
        <div class="slogan-tit">{{ $global.siteName }}</div>
        <div class="slogan-desc">
          用最短的时间遇见最大可能! ——
          基于时空大数据和人工智能的外勤排班管理系统
        </div>
      </div>
      <div class="btn-control">
        <button @click="openFreeTrial">
          申请试用
          <img src="/static/images/arrow_right_white.png" />
        </button>
      </div>
    </Banner>
    <div class="ability" id="worth">
      <div class="content">
        <div class="ability-title">我们为您带来的业务价值</div>
        <div class="worth-list">
          <div class="worth" v-for="item in worthList" :key="item.icon">
            <img :src="item.icon" alt="" />
            <p>{{ item.info }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="ability has-bg" id="engine">
      <div class="content">
        <div class="ability-title">ASE智能排班引擎</div>
        <div class="ability-sub-title">
          结合人工智能、TS、CNN等多种优化算法，自主研发了ASE（AI Schedule
          Engine）智能排班引擎
        </div>
        <div class="engine-wrap">
          <img class="engine" src="/static/images/engine.png" alt="" />
          <div class="engine-info-wrap">
            <p class="info">
              ASE（AI Schedule
              Engine）智能排班引擎，满足多种用户场景和多约束条件，动态规划线路，合理配置资源。
            </p>
            <div class="schedule-way">
              <div class="box condition">
                <div class="title">ASE引擎支持以下约束条件的智能排班：</div>
                <ul>
                  <li v-for="item in scheduleConditionList" :key="item">
                    {{ item }}
                  </li>
                </ul>
              </div>
              <img class="icon" src="/static/images/engine_arrow.png" />
              <div class="box result">
                <div class="title">自动输出每个业务员：</div>
                <ul>
                  <li v-for="item in scheduleResultList" :key="item">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
            <p class="remark">
              排班优化结果支持系统可视化展现，也支持Excel格式导出，也可以通过API对接，实现客户系统的实时同步对接。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="ability" id="district">
      <div class="content">
        <div class="ability-title">智能划分业务片区</div>
        <div class="ability-sub-title">
          基于深度机器学习方法，快速划分更合理的业务片区避免资源和任务“分配不均”
        </div>
        <div class="district-info">
          我们通过机器深度学习算法，人工智能分区引擎，构建起可支持三种不同分区需求的算法模型，实现合理分区。通过划分合理的业务片区，将客户资源合理分给各个业务人员，减少“分配不均”的员工抱怨，激发员工业务积极性，更便于外勤人员的管理和KPI设定考核。
          结合客户位置分布、客户等级、以及拜访频次、市场资源、预估销售额等现实条件内容，我们通过机器深度学习算法，人工智能分区引擎，构建起可支持：工作量均衡分区、销售目标均衡分区、市场潜力资源均衡分区。三种不同需求的分区算法模型，实现合理分区，保障各业务员的目标达成情况下实际执行的工作量最小，任务划分不重不漏。
        </div>
        <div class="district-list">
          <div class="district" v-for="item in districtList" :key="item.icon">
            <img :src="item.icon" alt="" />
            <p>{{ item.info }}</p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="ability" id="function">
      <div class="content">
        <div class="ability-title">产品功能介绍</div>
        <div class="product-introduce">
          <div class="product-introduce-title">客户拜访智能排班规划</div>
          <div class="product-introduce-info">
            我们将传统表格排班方式可视化，使操作更加简洁同时提高信息整合程度。基于多约束条件下的智能算法规划能力，自动迭代优化路线规划模型，高效合理统筹排班规划及路线建议。
          </div>
          <img class="schedule-img" src="/static/images/schedule.png" alt="" />
        </div>
        <div class="product-introduce">
          <div class="product-introduce-title">销售人员拜访日程管理</div>
          <div class="product-introduce-info">
            销售人员在移动端接收排班规划的每日拜访日程，同时支持用户调整行程，添加新行程
          </div>
          <div class="manage-list">
            <div class="manage" v-for="item in manageList" :key="item.icon">
              <img :src="item.icon" alt="" />
              <p>{{ item.info }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ability has-bg" id="advantage">
      <div class="content">
        <div class="ability-title">产品服务优势</div>
        <div class="advantage-list">
          <div class="advantage" v-for="item in advantageList" :key="item.icon">
            <img class="default-icon" :src="item.icon" alt="" />
            <img class="active-icon" :src="item.iconActive" alt="" />
            <div class="text">
              <p class="title">{{ item.title }}</p>
              <p class="info">{{ item.info }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-bottom">
      <p>{{ $global.siteName }}，用最短的时间，遇见最大可能</p>
      <p>Less is More</p>
      <button @click="openFreeTrial" class="apply-btn">
        申请试用
        <img src="/static/images/arrow_right_white.png" />
      </button>
    </div>
    <IndexContact @showFreeTrialModal="openFreeTrial"></IndexContact>
    <MyModal v-if="freeTrialShow" @closeMyModal="closeFreeTrial">
      <FreeTrial
        @success="applyTrialSuccess"
        @closeFreeTrial="closeFreeTrial"
      ></FreeTrial>
    </MyModal>
    <MyModal
      v-if="applyTrialSuccessModalShow"
      @closeMyModal="closeFreeTrialSuccessModal"
    >
      <ApplyTrialSuccess></ApplyTrialSuccess>
    </MyModal>
  </FrontPageTmpl>
</template>

<script>
import Banner from "./Banner";
import FrontPageTmpl from "./FrontPageTmpl.vue";
import MyModal from "./MyModal.vue";
import FreeTrial from "./FreeTrial.vue";
import ApplyTrialSuccess from "../components/ApplyTrialSuccess.vue";
import IndexContact from "../components/IndexContact.vue";

export default {
  data() {
    return {
      bannerImgs: ["/static/images/banner@2x.png"],
      worthList: [
        { icon: "/static/images/worth_1.png", info: "拜访客户在途时长减少43%" },
        {
          icon: "/static/images/worth_2.png",
          info: "单客户平均消耗里程减少55%"
        },
        { icon: "/static/images/worth_3.png", info: "日均拜访客户数增加30%" },
        { icon: "/static/images/worth_4.png", info: "客户拜访频次满足率为100%" }
      ],
      scheduleConditionList: [
        "业务员数量",
        "每个客户拜访停留时长",
        "业务员假期",
        "客户拜访频次",
        "每日工作时间段",
        "客户拜访周期",
        "每日休息时间段",
        "客户拜访时间窗口",
        "客户等级",
        "交通方式（驾车、公交、骑行、步行）"
      ],
      scheduleResultList: [
        "每日拜访客户数量",
        "每日拜访客户的清单",
        "每个客户拜访时间",
        "每日拜访客户的详细路线",
        "拜访客户的交通换乘方式"
      ],
      districtList: [
        {
          icon: "/static/images/district_1.png",
          info: "工作量均衡分区"
        },
        {
          icon: "/static/images/district_2.png",
          info: "销售目标均衡分区"
        },
        { icon: "/static/images/district_3.png", info: "市场潜力资源均衡分区" }
      ],
      manageList: [
        {
          icon: "/static/images/schedule_manage_1.png",
          info: "我的日程"
        },
        {
          icon: "/static/images/schedule_manage_2.png",
          info: "日程地图"
        },
        {
          icon: "/static/images/schedule_manage_3.png",
          info: "日程详情"
        },
        {
          icon: "/static/images/schedule_manage_4.png",
          info: "日程统计"
        }
      ],
      advantageList: [
        {
          icon: "/static/images/advantage_1.png",
          iconActive: "/static/images/advantage_1_active.png",
          title: "全面的客户覆盖",
          info:
            "目标客户拜访周期内100%覆盖，拜访频次完全达标，拜访间隔合理，挖掘更多的客户机会"
        },
        {
          icon: "/static/images/advantage_2.png",
          iconActive: "/static/images/advantage_2_active.png",
          title: "精准的业务触达",
          info:
            "精准定位客户画像，为客户业务量身定做符合业务的排班系统，保证软件的应用场景与业务完全匹配"
        },
        {
          icon: "/static/images/advantage_3.png",
          iconActive: "/static/images/advantage_3_active.png",
          title: "超幅的成本节约",
          info:
            "SaaS轻量级服务模式，节约IT投入、时间成本、运维成本、人力成本、硬件成本，打造更快、更省钱、更便捷的服务体系"
        },
        {
          icon: "/static/images/advantage_4.png",
          iconActive: "/static/images/advantage_4_active.png",
          title: "极高的效率提升",
          info:
            "极大的缩减销售人员在拜访客户里程碑上花费的时间成本，用最短的路去见更多的客户，有效的避免客户遗漏"
        }
      ],
      freeTrialShow: false,
      applyTrialSuccessModalShow: false
    };
  },
  methods: {
    openFreeTrial() {
      this.freeTrialShow = true;
    },
    closeFreeTrial() {
      this.freeTrialShow = false;
    },
    closeFreeTrialSuccessModal() {
      this.applyTrialSuccessModalShow = false;
    },
    // 申请试用成功
    applyTrialSuccess() {
      this.closeFreeTrial();
      this.applyTrialSuccessModalShow = true;
      setTimeout(() => {
        this.closeFreeTrialSuccessModal();
      }, 5000);
    }
  },
  mounted() {},
  components: {
    Banner,
    IndexContact,
    FrontPageTmpl,
    MyModal,
    FreeTrial,
    ApplyTrialSuccess
  }
};
</script>

<style lang="scss">
@import "../assets/stylesheets/static";
#newBridge .icon-right-bottom {
  right: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Static.vue